import React from 'react';

export default {
  title: 'Dados pessoais e de contato',
  address: 'Endereço',
  privacy: 'Privacidade de dados',
  form: {
    addressLabel: 'Endereço *',
    addressPlaceholder: 'Seu endereço',
    birthCountryLabel: 'País de nascimento *',
    birthCountryPlaceholder: 'Selecione aqui',
    birthDateLabel: 'Data de nascimento *',
    birthDatePlaceholder: 'DD/MM/AAAA',
    cityLabel: 'Cidade *',
    cityPlaceholder: 'Sua cidade',
    companyNameLabel: 'Razão Social *',
    companyNameLabelPlaceholder: 'Digite Aqui',
    companyResponsible: 'Representante Legal *',
    companyResponsiblePlaceholder: 'Digite Aqui',
    complementLabel: 'Complemento *',
    complementPlaceholder: 'Apt 00',
    countryLabel: 'País de residência *',
    countryPlaceholder: 'Seu país',
    cpfCnpjLabel: 'CPF ou CNPJ *',
    documentLabel: 'Documento *',
    documentPlaceholder: '000.000.000-00',
    emailLabel: 'E-mail *',
    emailPlaceholder: 'Seu e-mail',
    foreignerLabel: 'Sou estrangeiro',
    isCompanyLabel: '',
    knowledgeLabel: 'Nível de conhecimento',
    knowledgePlaceholder: 'Selecione o nível',
    mailSubscribeLabel: 'Receber novidades por e-mail',
    mailSubscribeTooltip: 'Com essa opção ativada você nos autoriza a enviar mensagens promocionais e as últimas atualizações de conteúdo das nossas plataformas.',
    nameLabel: 'Nome completo *',
    namePlaceholder: 'Seu nome completo',
    neighborhoodLabel: 'Bairro *',
    neighborhoodPlaceholder: 'Seu bairro',
    numberAndComplementLabel: 'Número ou Complemento *',
    numberAndComplementPlaceholder: '00',
    phoneLabel: 'Celular *',
    phonePlaceholder: '(00) 0 0000-0000',
    postalCodeHelp: 'Não sei meu CEP',
    postalCodeLabel: 'CEP *',
    postalCodePlaceholder: '00000-000',
    stateLabel: 'Estado *',
    statePlaceholder: 'Seu estado',
  },
  errors: {
    birthCountry: 'Selecione um país',
    birthDate: 'Digite uma data válida',
    postalCode: 'CEP inválido',
    cnpj: 'CNPJ inválido',
    cpf: 'CPF inválido',
    email: 'Digite um e-mail válido',
    numberAndComplement: 'Caracteres especiais não são permitidos',
    name: 'Por favor, forneça um nome com até 40 caracteres, incluindo um espaço',
    companyName: 'Certifique-se de que a razão social da empresa tenha até 50 caracteres, com um espaço entre eles.',
    phone: 'Digite um telefone válido',
    required: 'Campo obrigatório',
    state: '',
  },
  findMyCep: 'Não sei meu CEP',
  knowledgeLevels: {
    beginner: 'Iniciante',
    intermediary: 'Intermediário',
    technical: 'Técnico',
  },
  cancel: 'Cancelar',
  save: 'Salvar alterações',
  snackBar: {
    updateSuccess: 'Seus dados foram atualizados com sucesso!',
    updateError: 'Erro ao salvar seus dados!',
    cepError: 'Digite um CEP válido',
    emailAlreadyExists: 'Seu e-mail já está cadastrado no nosso sistema.',
  },

  changePassword: {
    title: 'Login Portal HostGator',
    modalTitle: 'Alterar Senha',
    contentDescription: () => (
      <>
        <div>Senha</div>
        <div>••••••••</div>
      </>
    ),
    SectionButtonLabel: 'Alterar Senha',
    currentPwLabel: 'Senha atual',
    currentPwPlaceholder: 'Insira sua senha atual',
    newPwLabel: 'Nova senha',
    newPwPlaceholder: 'Insira sua nova senha',
    repeatNewPwLabel: 'Repita a nova senha',
    repeatNewPwPlaceholder: 'Repita a nova senha',

    errorCurrentEmpty: 'Prencha sua senha atual.',
    errorEmptyField: 'Preencha este campo.',
    errorCurrentMinimumCharacters: 'A senha deve ter no mínimo 6 caracteres.',
    errorMinimumCharacters: 'A senha deve ter no mínimo 8 caracteres.',
    errorMinimumRequirements: 'Sua senha não tem os requisitos mínimos de segurança.',
    errorConfirmNew: 'A confirmação de senha não confere.',
    notifierSuccess: 'Senha alterada com sucesso!',
    notifierError: 'Não foi possível alterar sua senha. Entre em contato com o suporte.',

    requirementsList: {
      listTitle: 'Sua nova senha deve:',
      upperAndLowerItem: 'Incluir caracteres maiúsculos e minúsculos',
      numberLabel: 'Incluir pelo menos 1 número',
      symbolLabel: 'Incluir pelo menos 1 símbolo',
      minCharLabel: 'Ter pelo menos 8 caracteres',
      sameOnBothLabel: 'Ser a mesma em ambos os campos',
      differentPasswords: 'A nova senha não pode ser igual a senha atual.',
      matchConfirmation: 'Os campos da senha precisam ser iguais',
    },

    modalDescription: () => (
      <div>
        Apenas a
        {' '}
        <b>senha de login do Portal HostGator</b>
        {' '}
        será alterada com esta ação.
      </div>
    ),
    buttonLabel: 'Alterar senha',
    secondaryButtonLabel: 'Cancelar',

    requirementsTitle: 'Sua nova senha deve ter:',
    chips: {
      hasAtLeastEight: 'Mínimo de 8 caracteres',
      hasUpperCase: 'Letra maiúscula',
      hasLowerCase: 'Letra minúscula',
      hasSymbol: 'Caracteres especiais',
      hasNumber: 'Números',
    },
  },
  twoFactorAuth: {
    title: 'Autenticação de dois fatores',
    description: 'Adicione uma camada extra de segurança à sua conta.',
    status: {
      title: 'Status',
      enabled: 'Habilitado',
      disabled: 'Desabilitado',
    },
    statusButtonLabel: {
      enable: 'Habilitar',
      disable: 'Desabilitar',
    },
    snackbarRequestLimit: {
      title: 'Novo código enviado com sucesso.',
      label: attempts => `Resta${attempts === 1 ? '' : 'm'} ${attempts} tentativa${attempts === 1 ? '' : 's'} nas próximas 24 horas.`,
    },
    snackbarFeedback: type => `Autenticação de dois fatores ${type === 'enable' ? 'habilitada' : 'desabilitada'} com sucesso.`,
    chooseMethodModal: {
      title: type => `${type === 'enable' ? 'Habilitar' : 'Desabilitar'} autenticação de dois fatores`,
      description: 'Para garantir a segurança da sua conta, selecione como deseja receber o código de verificação:',
      email: 'E-mail no endereço:',
      sms: 'SMS no número:',
      whatsapp: 'WhatsApp no número:',
      primaryButtonLabel: 'Enviar código',
      secondaryButtonLabel: 'Voltar',
      notConfirmedPhoneValue: 'Não confirmado',
      noAttemptsLeftValue: 'Aguarde para tentar novamente',
      tooltip: {
        notConfirmedPhone: 'Este método não está disponível porque o número de telefone não foi confirmado. Para ativá-lo, acesse as informações da conta e confirme seu telefone de contato.',
        noAttemptsLeft: 'Você utilizou todas as solicitações de código disponíveis para este método. Será necessário aguardar 24h após a última solicitação para tentar novamente.',
      },
      requestLimit: {
        title: 'Você atingiu o limite de solicitações de código por hoje',
        description: 'Selecione outro método de verificação ou aguarde 24 horas para tentar novamente.',
        buttonLabel: 'Selecionar outro método de envio',
      },
    },
    validateCodeModal: {
      descriptionEmail: 'Enviamos um código temporário para o e-mail',
      descriptionSms: 'Enviamos um código temporário por SMS para o número',
      descriptionWhatsApp: 'Enviamos um código temporário por WhatsApp para o número',
      codeInputPlaceholder: 'Código de verificação',
      resendCodeMessage: 'Renviar código por e-mail em: ',
      resendButtonHelperText: 'Não recebeu o código?',
      resendCodeButtonLabel(time) {
        return time === '00:00' ? 'Reenviar' : `Reenviar em: ${time}`;
      },
      codeInputError: 'Código inválido',
      enable2FA: {
        title: 'Habilitar autenticação de dois fatores',
        buttonLabel: 'Validar código e habilitar',
      },
      disable2FA: {
        title: 'Desabilitar autenticação de dois fatores',
        warning: {
          title: 'Essa ação diminuirá a segurança da sua conta',
          description: 'Recomendamos manter essa camada extra de proteção para defender sua conta contra acessos não autorizados e possíveis fraudes.',
        },
        buttonLabel: 'Validar código e desabilitar',
      },
    },
  },
};
